import {
  SAVE_USER_INFO,
  SUBMITTED_PROFILE,
  PROFILE_SET,
  NEW_PROFILE_INVALIDATED,
  SUBMIT_PROFILE_UPDATE,
  STORE_UPDATED_PROFILE,
  OPEN_PROFILE_UPDATE_MODAL,
  CLOSE_PROFILE_UPDATE_MODAL,
  INVALIDATE_PROFILE_UPDATE,
} from './actionTypes';
import { get, post, update } from '../utils/communications';
import { apiEndpoint } from '../utils/env';
import toFinish from '../utils/toFinish';
import { localGet, localSet } from '../utils/localStorage';

export const saveUserInfo = (user, currentOrganisation) => ({
  type: SAVE_USER_INFO,
  payload: {
    user,
    currentOrganisation,
  },
});

export const getUserInfo = () => async (dispatch) => {
  const [userErr, resp] = await toFinish(get(`${apiEndpoint}/users/user`));
  if (userErr) {
    return Promise.reject(userErr);
  }
  const fallbackOrganisation = resp.data.attributes.organisationsId[0];
  const savedOrganisation = localGet('organisation', fallbackOrganisation);
  localSet('organisation', savedOrganisation);
  const userInfoToSave = { ...resp.data.attributes };
  userInfoToSave.role = userInfoToSave.role[savedOrganisation];
  return dispatch(saveUserInfo(userInfoToSave, savedOrganisation));
};

const startSetProfile = () => ({
  type: SUBMITTED_PROFILE,
});

const invalidateNewProfile = message => ({
  type: NEW_PROFILE_INVALIDATED,
  payload: {
    message,
  },
});

const finishSetProfile = () => ({
  type: PROFILE_SET,
});

export const setUserProfile = info => async (dispatch) => {
  dispatch(startSetProfile());
  const body = {
    data: {
      type: 'users',
      attributes: { ...info },
    },
  };
  post(`${apiEndpoint}/users/register`, body)
    .then((res) => {
      if (res.errors) {
        return dispatch(invalidateNewProfile(res.errors[0].detail));
      }
      return dispatch(finishSetProfile());
    })
    .catch((e) => {
      console.log('error', e);
    });
};

export const openUpdateProfileModal = () => ({
  type: OPEN_PROFILE_UPDATE_MODAL,
});

export const closeUpdateProfileModal = () => ({
  type: CLOSE_PROFILE_UPDATE_MODAL,
});

const startProfileUpdate = () => ({
  type: SUBMIT_PROFILE_UPDATE,
});

const storeUpdatedProfile = info => ({
  type: STORE_UPDATED_PROFILE,
  payload: {
    info,
  },
});

const invalidateProfileUpdate = errors => ({
  type: INVALIDATE_PROFILE_UPDATE,
  payload: {
    errors,
  },
});

export const updateUserProfile = info => async (dispatch) => {
  const { language, ...inforest } = info;
  const oldLang = localGet('lang', null);
  localSet('lang', language);

  dispatch(startProfileUpdate());
  const body = {
    data: {
      type: 'users',
      attributes: { ...inforest },
    },
  };
  update(`${apiEndpoint}/users/user`, body)
    .then((resp) => {
      if (language !== oldLang) {
        window.location.reload();
      }
      return dispatch(storeUpdatedProfile(resp.data.attributes.updatedProfile))
    })
    .catch(err => dispatch(invalidateProfileUpdate(err.errors)));
};



// WEBPACK FOOTER //
// ./src/actions/user.js